<!-- Validation Result -->
<div class="section-card" *ngIf="isValidating">
    <div class="loading-state">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Validando información del instructivo…</p>
    </div>
</div>

<div class="validation-card" *ngIf="validation && !isValidating">
    <div *ngIf="validation.isValid" class="validation-success">
        <div class="success-header">
            <mat-icon>check_circle</mat-icon>
            <h3>Validación Exitosa</h3>
        </div>
        <p>
            Todos los datos requeridos están completos y correctos. Puede enviar
            el instructivo.
        </p>
    </div>

    <div
        *ngIf="!validation.isValid && validation.errors.length > 0"
        class="validation-errors"
    >
        <div class="error-header">
            <mat-icon>error</mat-icon>
            <h3>Errores de Validación</h3>
        </div>
        <ul>
            <li *ngFor="let error of validation.errors">{{ error }}</li>
        </ul>
    </div>

    <div *ngIf="validation.warnings.length > 0" class="validation-warnings">
        <div class="warning-header">
            <mat-icon>warning_amber</mat-icon>
            <h3>Advertencias</h3>
        </div>
        <ul>
            <li *ngFor="let warning of validation.warnings">{{ warning }}</li>
        </ul>
    </div>
</div>

<!-- Resumen estilo documento -->
<div class="section-card section-card--summary-doc" *ngIf="!isValidating">
    <div class="ie-doc">
        <!-- Encabezado -->
        <div class="doc-banner">
            <div class="doc-banner__title">
                <mat-icon>description</mat-icon>
                <div>
                    <h2>Instructivos de Embarque</h2>
                    <p>{{ dash(formData.customerName) }} • {{ summarySeasonLine }}</p>
                </div>
            </div>
            <div class="doc-banner__badge">
                <label>N° Booking</label>
                <span>{{ dash(summaryBookingNumber) }}</span>
            </div>
        </div>

        <div class="catalog-loading" *ngIf="catalogsLoading">
            <mat-spinner diameter="28"></mat-spinner>
            <span>Cargando textos de catálogo…</span>
        </div>

        <!-- Información General + Exportador -->
        <div class="doc-row doc-row--two-cols">
            <div class="doc-card">
                <h3><mat-icon>description</mat-icon> Información General</h3>
                <div class="doc-fields">
                    <div class="doc-field">
                        <mat-icon>person</mat-icon>
                        <div>
                            <label>Cliente</label>
                            <span>{{ dash(formData.customerName) }}</span>
                        </div>
                    </div>
                    <div class="doc-field">
                        <mat-icon>directions_boat</mat-icon>
                        <div>
                            <label>Naviera</label>
                            <span>{{ dash(formData.carrierName) }}</span>
                        </div>
                    </div>
                    <div class="doc-field">
                        <mat-icon>inventory_2</mat-icon>
                        <div>
                            <label>Tipo de Embarque</label>
                            <span>{{ typeOfShipmentName }}</span>
                        </div>
                    </div>
                    <div class="doc-field">
                        <mat-icon>badge</mat-icon>
                        <div>
                            <label>RUT Cliente</label>
                            <span>{{ dash(formData.customerTaxIdentificationNumber) }}</span>
                        </div>
                    </div>
                    <div class="doc-field">
                        <mat-icon>mail</mat-icon>
                        <div>
                            <label>Email Cliente</label>
                            <span>{{ dash(formData.customerContactEmail) }}</span>
                        </div>
                    </div>
                    <div class="doc-field">
                        <mat-icon>support_agent</mat-icon>
                        <div>
                            <!-- Mejor dato disponible: no existe un campo "Agente de Embarque"
                                 separado — reusa el contacto de atención del cliente. -->
                            <label>Agente de Embarque</label>
                            <span>{{ dash(formData.customerAttentionContactName) }}</span>
                        </div>
                    </div>
                    <div class="doc-field">
                        <mat-icon>description</mat-icon>
                        <div>
                            <label>Emisor B/L</label>
                            <span>{{ dash(formData.billOfLadingIssuer) }}</span>
                        </div>
                    </div>
                    <div class="doc-field">
                        <mat-icon>event</mat-icon>
                        <div>
                            <label>Días Tránsito</label>
                            <span>{{ dash(formData.transitDays) }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="doc-card">
                <h3><mat-icon>business</mat-icon> Exportador</h3>
                <div class="doc-fields">
                    <div class="doc-field">
                        <mat-icon>business</mat-icon>
                        <div>
                            <label>Exportador</label>
                            <span>{{ dash(formData.shipperName) }}</span>
                        </div>
                    </div>
                    <div class="doc-field">
                        <mat-icon>badge</mat-icon>
                        <div>
                            <label>RUT</label>
                            <span>{{ dash(formData.shipperTaxIdentificationNumber) }}</span>
                        </div>
                    </div>
                    <div class="doc-field doc-field--full">
                        <mat-icon>mail</mat-icon>
                        <div>
                            <label>Email</label>
                            <span>{{ dash(formData.shipperEmail) }}</span>
                        </div>
                    </div>
                    <div class="doc-field doc-field--full">
                        <mat-icon>place</mat-icon>
                        <div>
                            <label>Dirección</label>
                            <span class="multiline">{{ dash(formData.shipperAddress) }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Itinerarios -->
        <div class="doc-card doc-card--full">
            <h3><mat-icon>directions_boat</mat-icon> Itinerarios</h3>
            <div class="doc-inline-fields">
                <div class="doc-inline-field">
                    <label>Nave / Viaje</label>
                    <span>{{ vesselVoyageLine }}</span>
                </div>
                <div class="doc-inline-field">
                    <label>Puerto de Embarque (POL)</label>
                    <span>{{ dash(formData.portOfLoadingName) }}</span>
                </div>
                <div class="doc-inline-field">
                    <label>Puerto de Destino (POD)</label>
                    <span>{{ dash(formData.portOfDischargeName) }}</span>
                </div>
                <div class="doc-inline-field">
                    <label>Destino Final</label>
                    <span>{{ dash(formData.portOfDischargeName) }}</span>
                </div>
                <div class="doc-inline-field">
                    <label>País Destino Final</label>
                    <span>{{ dash(summaryFinalDestinationCountryPerPod) }}</span>
                </div>
            </div>

            <div class="deadlines-box">
                <div class="deadlines-box__title">
                    <mat-icon>schedule</mat-icon> Fechas del Viaje
                </div>
                <div class="deadlines-content">
                    <div class="deadline-item">
                        <label>ETD</label>
                        <span class="date-highlight">{{ formatDate(formData.etd) }}</span>
                    </div>
                    <div class="deadline-item">
                        <label>ETA</label>
                        <span class="date-highlight">{{ formatDate(formData.eta) }}</span>
                    </div>
                    <div class="deadline-item">
                        <label>Corte Documental</label>
                        <span>{{ formatDate(formData.cutOffDocumental) }}</span>
                    </div>
                    <div class="deadline-item">
                        <label>Stacking</label>
                        <span>{{ stackingDescription }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Por instructivo -->
        <div class="doc-card doc-card--full doc-card--instructivo" *ngFor="let instr of instructivos; let instrIdx = index">
            <h3><mat-icon>description</mat-icon> Instructivo #{{ instrIdx + 1 }}</h3>
            <div class="instructivo-grid">
                <!-- Consignatario / Notificante -->
                <div class="instructivo-col instructivo-col--parties">
                    <label>Consignatario</label>
                    <span>{{ dash(instr.consigneeName) }}</span>
                    <ng-container *ngIf="instr.consigneeAddress">
                        <label class="sub">Dirección Consignatario</label>
                        <span class="multiline">{{ dash(instr.consigneeAddress) }}</span>
                    </ng-container>
                    <label>Notificante</label>
                    <span>{{ dash(instr.notifyName) }}</span>
                    <ng-container *ngIf="instr.notifyAddress">
                        <label class="sub">Dirección Notificante</label>
                        <span class="multiline">{{ dash(instr.notifyAddress) }}</span>
                    </ng-container>
                </div>

                <!-- Antecedentes financieros -->
                <div class="instructivo-col instructivo-col--financial">
                    <div class="doc-field">
                        <mat-icon>sell</mat-icon>
                        <div>
                            <label>Ref. Cliente</label>
                            <span>{{ dash(instr.customerReference) }}</span>
                        </div>
                    </div>
                    <div class="doc-field">
                        <mat-icon>view_in_ar</mat-icon>
                        <div>
                            <label>Pallets Chep</label>
                            <span>{{ palletsChepSummaryFor(instr) }}</span>
                        </div>
                    </div>
                    <div class="doc-field">
                        <mat-icon>payments</mat-icon>
                        <div>
                            <label>Forma de Pago</label>
                            <span>{{ dash(Labels.methodOfPayment(instr.methodOfPaymentId, catalogs)) }}</span>
                        </div>
                    </div>
                    <div class="doc-field">
                        <mat-icon>description</mat-icon>
                        <div>
                            <label>Cláusula de Venta</label>
                            <span>{{ dash(Labels.clauseOfSale(instr.clauseOfSaleId, catalogs)) }}</span>
                        </div>
                    </div>
                    <div class="doc-field">
                        <mat-icon>storefront</mat-icon>
                        <div>
                            <label>Modalidad de Venta</label>
                            <span>{{ dash(Labels.modeOfSale(instr.modeOfSaleId, catalogs)) }}</span>
                        </div>
                    </div>
                    <div class="doc-field">
                        <mat-icon>local_shipping</mat-icon>
                        <div>
                            <label>Condición Flete</label>
                            <span>{{ dash(Labels.freight(instr.freightCondition)) }}</span>
                        </div>
                    </div>
                    <div class="doc-field">
                        <mat-icon>category</mat-icon>
                        <div>
                            <label>Tipo de Carga</label>
                            <span>{{ dash(Labels.typeOfCargo(instr.typeOfCargoId, catalogs)) }}</span>
                        </div>
                    </div>
                    <div class="doc-field">
                        <mat-icon>inventory_2</mat-icon>
                        <div>
                            <label>{{ formData.typeOfShipmentId === TypeOfShipment.Pallet ? 'N° Pallets' : 'N° Cntr' }}</label>
                            <span>{{ totalContainersOrPalletsFor(instr) || '—' }}</span>
                        </div>
                    </div>
                </div>

                <!-- Especies (todos los ítems del instructivo, en una sola tabla) -->
                <div class="instructivo-col instructivo-col--species">
                    <h4>Especies</h4>
                    <div class="species-table" *ngIf="flattenedSpeciesFor(instr).length; else noSpecies">
                        <div class="species-block" *ngFor="let sp of flattenedSpeciesFor(instr)">
                            <div class="species-row species-row--identity">
                                <div><label>Especie</label><span>{{ dash(sp.speciesName) }}</span></div>
                                <div><label>Variedad</label><span>{{ dash(sp.variety) }}</span></div>
                                <div><label>Condición</label><span>{{ dash(sp.condition) }}</span></div>
                                <div><label>N° Cajas</label><span>{{ sp.boxCount }}</span></div>
                                <div><label>Tipo Caja</label><span>{{ dash(Labels.speciesPackage(sp, catalogSnap)) }}</span></div>
                            </div>
                            <div class="species-row species-row--weights">
                                <div><label>Kg Neto/Caja</label><span>{{ dash(sp.netWeightKgPerBox) }}</span></div>
                                <div><label>Kg Bruto/Caja</label><span>{{ dash(sp.grossWeightKgPerBox) }}</span></div>
                                <div><label>Marca</label><span>{{ dash(sp.brand) }}</span></div>
                                <div><label>Kg Neto Total</label><span>{{ dash(sp.totalNetWeightKg) }}</span></div>
                                <div><label>Kg Bruto Total</label><span>{{ dash(sp.totalGrossWeightKg) }}</span></div>
                                <div><label>FOB U.</label><span>{{ dash(sp.fobUnitPrice) }}</span></div>
                                <div><label>FOB Ítem</label><span>{{ dash(sp.fobItemTotal) }}</span></div>
                            </div>
                        </div>
                    </div>
                    <ng-template #noSpecies><p class="no-species">Sin especies cargadas.</p></ng-template>
                </div>
            </div>
        </div>

        <!-- Observaciones: solo si hay algo real que mostrar -->
        <div class="doc-card doc-card--full" *ngIf="hasObservations">
            <h3><mat-icon>notes</mat-icon> Observaciones</h3>
            <div class="observations-box">
                <p>{{ allObservationsText }}</p>
            </div>
        </div>

        <!-- Pie -->
        <div class="doc-footer">
            <div class="doc-footer__tagline">
                <mat-icon>sailing</mat-icon>
                Instructivo preparado para asegurar un embarque eficiente y sin contratiempos.
            </div>
            <div class="doc-footer__meta">
                <span>Emitido el {{ summaryDocDate }}</span>
                <strong>{{ dash(formData.customerName) }}</strong>
            </div>
        </div>
    </div>
</div>

<!-- Success message -->
<div class="section-card success-final" *ngIf="submitSuccess">
    <div class="success-message">
        <mat-icon>check_circle</mat-icon>
        <h3>¡{{ createdIds.length === 1 ? 'Instructivo Creado' : createdIds.length + ' Instructivos Creados' }} Exitosamente!</h3>
        <p *ngFor="let id of createdIds; let i = index">
            Instructivo #{{ i + 1 }} — ID: <strong>{{ id }}</strong>
        </p>
        <div class="actions">
            <button mat-stroked-button (click)="goToItinerarios()">
                Volver a Itinerarios
            </button>
        </div>
    </div>
</div>

<!-- Error message -->
<div class="section-card error-final" *ngIf="submitError && !submitSuccess">
    <div class="error-message">
        <mat-icon>error_outline</mat-icon>
        <h3>Error al Crear Instructivo</h3>
        <p>{{ submitError }}</p>
    </div>
</div>

<!-- Submit button (only if validation passed) -->
<div class="submit-section" *ngIf="!submitSuccess && validation?.isValid">
    <button
        mat-raised-button
        color="accent"
        [disabled]="!canSubmit"
        (click)="submitShippingInstruction()"
        class="submit-btn"
    >
        <mat-icon *ngIf="!isSubmitting">send</mat-icon>
        <mat-spinner *ngIf="isSubmitting" diameter="20"></mat-spinner>
        {{ isSubmitting ? 'Enviando…' : 'Enviar Instructivo' }}
    </button>
</div>
